import {
  type ReservedUsernamesResponse,
  reservedUsernamesResponseDto,
  type UpdateReservedUsernamesBody,
} from '@planuze/admin-contracts';
import { ApiError, parseJson, readErrorCode, request } from './http.js';

/* Cliente REST dos @username reservados (ADR-0730). GET lê a lista LIVE do config-service; PUT
   (super_admin) substitui a lista inteira via read-modify-write no admin-service. */

async function reservedError(res: Response): Promise<ApiError> {
  const code = await readErrorCode(res);
  return new ApiError(res.status, 'server_error', code || 'request failed', code);
}

export async function getReservedUsernames(): Promise<readonly string[]> {
  const res = await request('/v1/admin/reserved-usernames');
  if (!res.ok) throw await reservedError(res);
  return (await parseJson(res, reservedUsernamesResponseDto)).usernames;
}

export async function updateReservedUsernames(
  body: UpdateReservedUsernamesBody,
): Promise<ReservedUsernamesResponse> {
  const res = await request('/v1/admin/reserved-usernames', { method: 'PUT', body });
  if (!res.ok) throw await reservedError(res);
  return parseJson(res, reservedUsernamesResponseDto);
}
